import React, {useState, useEffect, createRef} from 'react';
import {Button, Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import {httpPaginationPost} from './../../../util/Rest';
import {useDispatch} from 'react-redux';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../constants/ReusableConstants';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import AddIcon from '@material-ui/icons/AddOutlined';
import {defaultRows} from '../../../constants/ReusableTablePagination';
import {
  fetchTransitionData,
  fetchTransitionMainData,
  resetTransitionTable,
} from '../../../redux/reducers/TranslationTable';

export default function LookupMaintenanceTable({
  searchData,
  setSubmit,
  submit,
  setValue,
  setRowData,
  TranslationTableAccess,
}) {
  const [arrayLast, setArrayLast] = useState(false);
  const tableRef = createRef();
  const [rows, setRows] = useState(defaultRows);
  const dispatch = useDispatch();

  const columns = [
    {
      title: 'Code',
      field: 'code',
    },
    {
      title: 'Description',
      field: 'description',
    },
    {
      title: 'Default Value',
      field: 'defaultValue',
    },
  ];

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  useEffect(() => {
    dispatch(resetTransitionTable());
  }, []);
  return (
    <>
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-toolbar-icons custom-actions-icon new-standard-textfields">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `data-manager/record/searchall/transalations`;
                const bodyObj = {
                  limit: query?.pageSize ? query?.pageSize : null,
                  typeCode: searchData?.lookupCode ? searchData?.lookupCode?.toUpperCase() : '',
                  description: searchData?.description ? searchData?.description : '',
                  search: query?.search ? query?.search : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };

                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              toolbar: true,
              pageSize: rows,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
            actions={[
              {
                icon: () => <EditOutlinedIcon />,
                tooltip: 'Edit',
                onClick: (event, rowData) => {
                  dispatch(fetchTransitionData(rowData?.code));
                  dispatch(fetchTransitionMainData(rowData?.code));
                  setValue(1);
                  setRowData(rowData);
                },
              },
              {
                icon: () => (
                  <>
                    <div className="mb-1">
                      <Button
                        type="button"
                        variant="outlined"
                        className={`search-btn`}
                        startIcon={<AddIcon />}
                        disabled={!TranslationTableAccess?.add}
                      >
                        Add Translation
                      </Button>
                    </div>
                  </>
                ),
                disabled: !TranslationTableAccess?.add,
                isFreeAction: true,
                onClick: () => {
                  setRowData({});
                  setValue(1);
                },
              },
            ]}
          />
        </div>
      </Grid>
    </>
  );
}
